import util from '@bmp-vue/core/api/util'

const controller = 'ParceiroDuplicata'
const route = 'Parceiros'

export default Object.assign({}, util.GetCrud(controller, null), {
    GetConfiguracao: function (codigoParceiro) {
        return util.Axios.Get(`${route}/${codigoParceiro}/duplicata/configuracao`)
    },

    AtualizarConfiguracao: function (codigoParceiro, adesaoDuplicata) {
        return util.Axios.Put(`${route}/${codigoParceiro}/duplicata/configuracao`, '', { codigoParceiro, adesaoDuplicata })
    },

    GetClientId: function (codigoParceiro) {
        return util.Axios.Get(`${route}/${codigoParceiro}/duplicata/client-id`)
    },

    SolicitarCriacaoClientId: function (codigoParceiro, clientId) {
        return util.Axios.Post(
            `${route}/${codigoParceiro}/duplicata/client-id/solicitar-criacao`,
            { codigoParceiro, clientId }
        )
    },

    GetScopesDisponiveis: function (codigoParceiro) {
        return util.Axios.GetAll(`${route}/${codigoParceiro}/duplicata/scopes/disponiveis`)
    },

    GetScopesVinculados: function (codigoParceiro) {
        return util.Axios.GetAll(`${route}/${codigoParceiro}/duplicata/scopes/vinculados`)
    },

    VincularScopes: function (codigoParceiro, scopes) {
        return util.Axios.Post(
            `${route}/${codigoParceiro}/duplicata/scopes/vincular`,
            { codigoParceiro, scopes }
        )
    },

    RemoverScope: function (codigoParceiro, scope) {
        return util.Axios.Post(
            `${route}/${codigoParceiro}/duplicata/scopes/remover`,
            { codigoParceiro, scope }
        )
    },

    GetSecrets: function (codigoParceiro) {
        return util.Axios.GetAll(`${route}/${codigoParceiro}/duplicata/secrets`)
    },

    CadastrarSecret: function (codigoParceiro, description, publicKey) {
        return util.Axios.Post(
            `${route}/${codigoParceiro}/duplicata/secrets`,
            { codigoParceiro, description, publicKey, value: publicKey }
        )
    },

    RemoverSecret: function (codigoParceiro, type, value) {
        return util.Axios.Delete(`${route}/${codigoParceiro}/duplicata/secrets?type=${encodeURIComponent(type || 'JWK')}&value=${encodeURIComponent(value || '')}`)
    },

    GetClaimCodigoParceiro: function (codigoParceiro) {
        return util.Axios.Get(`${route}/${codigoParceiro}/duplicata/claims/codigo-parceiro`)
    },

    SolicitarCriacaoClaimCodigoParceiro: function (codigoParceiro) {
        return util.Axios.Post(
            `${route}/${codigoParceiro}/duplicata/claims/codigo-parceiro/solicitar-criacao`,
            { codigoParceiro }
        )
    }
})
